import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { HelpType, ResponsiveValue } from 'store/slices/help';
import infoIcon from 'images/info-icon.png';
import warningIcon from 'images/warning-icon.png';
import errorIcon from 'images/error-icon.png';
import { styled } from 'theme';
import { useHelpOverlayResponsiveValues } from 'hooks/useHelpOverlayResponsiveValues';

const StyledTypography = styled(Typography)(({ theme }) => ({
    marginBottom: `${theme.preferredSpace}px`,
}));

const getHelpIcon = (type: HelpType) => {
    switch (type) {
    case 'WARNING':
        return warningIcon;
    case 'ERROR':
        return errorIcon;
    default:
        return infoIcon;
    }
};

interface Props {
    message: ResponsiveValue<string>;
    type: HelpType;
    onPrev?: () => void;
    onNext?: () => void;
    onClose?: () => void;
    hasNext?: boolean;
    isFirst?: boolean;
    stepNumber: number;
    totalSteps: number;
}

export const StepComponent: React.FC<Props> = ({
    message,
    type,
    onPrev,
    onNext,
    onClose,
    hasNext,
    isFirst,
    stepNumber,
    totalSteps,
}) => {
    const renderedMessage = useHelpOverlayResponsiveValues(message);

    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={3}>
                <Box
                    component="img"
                    src={getHelpIcon(type)}
                    alt="Help Icon"
                    sx={{ width: 80, height: 80 }}
                />
            </Grid>

            <Grid item xs={9}>
                <StyledTypography variant="h4" sx={{ color: type.toLowerCase() }}>
                    {renderedMessage || 'No help message available.'}
                </StyledTypography>
            </Grid>

            <Grid item xs={12} container justifyContent="flex-end" spacing={1}>
                {!isFirst && (
                    <Grid item>
                        <Button variant="outlined" onClick={onPrev}>
                            ←
                        </Button>
                    </Grid>
                )}
                <Grid item>
                    <Button variant="outlined">
                        {`${stepNumber}/${totalSteps}`}
                    </Button>
                </Grid>
                {hasNext && (
                    <Grid item>
                        <Button variant="outlined" onClick={onNext}>
                            →
                        </Button>
                    </Grid>
                )}
                <Grid item>
                    <Button variant="contained" color="secondary" onClick={onClose}>
                        Close
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
};
